











































import { Component, Vue, Prop } from "vue-property-decorator";
import BaseComponent from "@/asdcom/BaseComponent"
import { AttachmentDto } from "@/asdcom/apiproxy/apiproxy.dto";

@Component
export default class AttachmentItemViewComponent extends BaseComponent {
  previewImage: string = "";
  showAttachmentPreview: boolean = false;
  @Prop({
    type: Array,
    required: true,
    default: () => {
      return [];
    }
  })
  attachments: AttachmentDto[];

  get attachList(){
      return this.attachments;
  }

  // previewAttachment(id: string) {
  //   this.$emit("previewAttachment", id)
  // }

  previewAttachment(id: string) {
    // abp.log.debug({ "attachments-component previewAttachment": id });
    this.$appsvs.vcpOnlineOk
      .retrieveAttachmentPreview(id)
      .then((res: string) => {
        this.previewImage = `data:image/jpeg;base64,${res}`;
        this.attachPreviewDialogVisible(true);
      });
  }

  attachPreviewDialogVisible(isVisible: boolean) {
    this.showAttachmentPreview = isVisible;
    if (!isVisible) {
      this.previewImage = "";
    }
  }

}
